import { render } from "./TechItsClientsCaseStudiesComp.vue?vue&type=template&id=3562f218&scoped=true"
import script from "./TechItsClientsCaseStudiesComp.vue?vue&type=script&lang=js"
export * from "./TechItsClientsCaseStudiesComp.vue?vue&type=script&lang=js"

import "./TechItsClientsCaseStudiesComp.vue?vue&type=style&index=0&id=3562f218&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3562f218"]])

export default __exports__